import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { guideFinanceApi, guideFinanceKeys } from '@/features/guide-finance/api/guide-finance.api';

export function useGuideWallet() {
  return useQuery({
    queryKey: guideFinanceKeys.wallet(),
    queryFn: guideFinanceApi.getWallet,
    refetchOnWindowFocus: true,
  });
}

export function useGuideWalletSummary() {
  return useQuery({
    queryKey: guideFinanceKeys.summary(),
    queryFn: guideFinanceApi.getSummary,
    refetchOnWindowFocus: true,
  });
}

export function useGuideTransactions(
  params?: { page?: number; limit?: number; transactionType?: string; status?: string },
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: guideFinanceKeys.transactions(params),
    queryFn: () => guideFinanceApi.getTransactions(params),
    enabled: options?.enabled ?? true,
  });
}

export function useGuideBankAccounts(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: guideFinanceKeys.bankAccounts(),
    queryFn: guideFinanceApi.listBankAccounts,
    enabled: options?.enabled ?? true,
  });
}

export function useGuideWithdrawals(
  params?: { page?: number; limit?: number; status?: string },
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: guideFinanceKeys.withdrawals(params),
    queryFn: () => guideFinanceApi.listWithdrawals(params),
    enabled: options?.enabled ?? true,
  });
}

export function useCreateWithdrawal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: guideFinanceApi.createWithdrawal,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: guideFinanceKeys.all });
    },
  });
}

export function useCreateBankAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: guideFinanceApi.createBankAccount,
    onSuccess: () => qc.invalidateQueries({ queryKey: guideFinanceKeys.all }),
  });
}

export function useSetPrimaryBankAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: guideFinanceApi.setPrimaryBankAccount,
    onSuccess: () => qc.invalidateQueries({ queryKey: guideFinanceKeys.all }),
  });
}

export function useDeleteBankAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: guideFinanceApi.deleteBankAccount,
    onSuccess: () => qc.invalidateQueries({ queryKey: guideFinanceKeys.all }),
  });
}
